import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from './utils/axios'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import Element from 'element-ui'
import './assets/css/element-style/theme/index.css'
import './assets/icon/iconfont.css'
Vue.use(Element)


Vue.config.productionTip = false;
Vue.prototype.axios = axios;

//路由埋点判断
router.beforeEach((to, from, next) => {
  // 页面上报
  try{
    MtaH5.pgv();
  }catch (e) {

  }
  next();
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
